module.exports = __webpack_public_path__ + "static/media/image-anak-3.8c54fbb0.png";